import { h, defineComponent, onUnmounted } from 'vue';
import { hasFeature, hasPermission, Permissions, user } from '@/ui/auth/auth';
import { renderForbiddenPage } from '../error/ForbiddenPage';
import ChecklistBuilder from '@/_legacy/views/ChecklistBuilder/ChecklistBuilder.vue';
import { pushRoute } from '@/ui/helpers';
import { locales, t } from '@/ui/i18n/i18n';
import { renderResourceTeaserPage } from '@/ui/pages/teasers/ResourceTeaserPage';
import { useCurrentRoute } from '@/ui/routes';
import { useEntityItemsStore } from '@/stores/conduct/entityItems';

const query = (locale: locales) => {
  switch (locale) {
    case 'es':
      return {
        withTour: '1',
        product_tour_id: '189889',
      };
    case 'de':
      return {
        withTour: '1',
        product_tour_id: '182165',
      };
    case 'pt-BR':
    case 'fr':
    case 'en':
    default:
      return {
        withTour: '1',
        product_tour_id: '168489',
      };
  }
};

export const ChecklistCreatePage = defineComponent({
  name: 'ChecklistCreatePage',
  setup() {
    if (!hasFeature('inspections')) {
      return renderResourceTeaserPage(t('common.inspections'));
    }

    if (!hasPermission(Permissions.MANAGE_CHECKLISTS)) {
      return renderForbiddenPage;
    }

    const entityItemsStore = useEntityItemsStore();
    const currentRoute = useCurrentRoute();
    const fromId = currentRoute.value.query.fromId ?? '';
    const fromTplId = currentRoute.value.query.fromTplId ?? '';
    const isCreatedFromAi = (currentRoute.value.query.fromAi ?? '') === 'true';
    const isCreatedFromPrompt = (currentRoute.value.query.fromPrompt ?? '') === 'true';
    const isCreatedFromFileUpload = (currentRoute.value.query.fromFileUpload ?? '') === 'true';

    //have to be a function, because must be postponed
    const propsF = () => ({
      resourceId: fromId.toString(),
      isCloning: !!fromId,
      templateId: fromTplId.toString(),
      isCreatedFromAi,
      isCreatedFromPrompt,
      isCreatedFromFileUpload,
    });

    onUnmounted(() => entityItemsStore.$reset());

    return function render() {
      //because of these cases with 2 types in properties we should use ts-ignore here
      /**
       * type: [Boolean, String],
       * default: false,
       */
      //ts vue typing does not compatible with 2+ types in props default. should be only 1
      // @ts-ignore
      return h('div', [h(ChecklistBuilder,
        {
          class: 'legacy checklist-builder',
          props: propsF(),
          on: {
            saved: () => {
              setTimeout(() => {
                pushRoute({
                  name: 'forms',
                  query: query(user.value.locale),
                });
              }, 1000);
            },
          },
        })]);
    };
  },
});
